import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/components/page/organization/info/index.ts